import { TFlex } from 'foundations-components/transitional/components/TFlex';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import styled from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const SeparatorText = styled.div.withConfig({
  displayName: "SidePanelSeparator__SeparatorText"
})(({
  theme
}) => ({
  color: theme.color['text-core-subtle'],
  fontSize: theme.typography['detail-200'].fontSize,
  fontWeight: theme.typography['body-300'].fontWeight,
  lineHeight: theme.typography['detail-200'].lineHeight,
  fontFamily: theme.typography['detail-200'].fontFamily,
  textAlign: 'center',
  paddingInline: theme.space['200']
}));
export const SidePanelSeparator = ({
  message
}) => {
  return /*#__PURE__*/_jsxs(TFlex, {
    alignItems: "center",
    blockSize: "36px",
    justifyContent: "center",
    marginBlockEnd: "200",
    marginBlockStart: "400",
    children: [/*#__PURE__*/_jsx(TFlex, {
      backgroundColor: "border-tertiary-default",
      blockSize: "1px",
      flexGrow: 1
    }), /*#__PURE__*/_jsx(SeparatorText, {
      children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: message
      })
    }), /*#__PURE__*/_jsx(TFlex, {
      backgroundColor: "border-tertiary-default",
      blockSize: "1px",
      flexGrow: 1
    })]
  });
};